import React from "react";
import { Fragment, useEffect, useState } from "react";
import { useTable, usePagination, useSortBy } from 'react-table';
import { useLocation } from "react-router-dom";
import { Button, ButtonGroup, Col, Dropdown, Form, Row, Stack } from "react-bootstrap";
import { DatasetDefault, DatasetModel } from "../../../models/dataset.model";
import { HeaderList } from "../../../components/HeaderList";
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LocaleService } from "../../../services/locale.service";
import { LocaleModel } from "../../../models/locale.model";

import TransporterService from "../../../services/transporter.service";
import { TransporterModel } from "../../../models/transporter.model";

import PredictionModelService from "../../../services/predictionModel.service";
import { PredictionModelModel } from "../../../models/predictionModel.model";

import { BranchService } from "../../../services/branch.service";
import { BranchModel } from "../../../models/branch.model";

import { EquipmentModel } from "../../../models/equipment.model";
import { EquipmentService } from "../../../services/equipment.service";

import { HeadDateModel } from "../../../models/headDate.model";

import { RequestInputOutputParamsModel, RequestInputOutputParamsModelDefault } from "../../../models/requestInputOutputParams.model";

import storageService from "../../../services/storage.service";

import { ForeCastService } from "../../../services/forecast.service";

import UtilService from "../../../services/util.service";
import InfiniteScroll from "react-infinite-scroll-component";
import BTable from 'react-bootstrap/Table';
import HelperService from "../../../services/helper.service";
import { faSortAlphaUp, faSortAlphaDown, faSort, faCalendarCheck, faExclamationTriangle, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import _ from 'lodash';


function Table({ columns, data, update, total_records, msgEmpty }) {
  let columnsToHidden = [];
  if (columns) {
    for (let i = 0; i < columns.length; i++) {
      const colFather = columns[i];
      if (colFather.columns) {
        for (let j = 0; j < colFather.columns.length; j++) {
          const colChild = colFather.columns[j];
          if (colChild.isVisible !== undefined && colChild.isVisible === false) {
            columnsToHidden.push(colChild.id || colChild.accessor);
          }
        }
      }
      else {
        if (colFather.isVisible !== undefined && colFather.isVisible === false) {
          columnsToHidden.push(colFather.id || colFather.accessor);
        }
      }
    }
  }

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    allColumns,
    rows
  } = useTable(
    {
      columns,
      data,
      initialState: {
        //pageIndex: 0,
        hiddenColumns: columnsToHidden
      },
    },
    useSortBy,
    usePagination
  )

  const formatCellStyleHeader = (cellInfo: any) => {
    const style={
      border: 'none',
      background: cellInfo.background,
      color: 'white',
      fontWeight: 600,
      textAlign: 'center'
    };
  return style;
  }

  const formatCellStyle = (cellInfo: any) => {
    const style = {
      width: '100%',
      height: '100%',
      padding: 2
    };

    const columnId = cellInfo.column.id;
    let dayName = "";

    switch (columnId) {
      case "d01Value":
        dayName = "d01";
        break;
      case "d02Value":
        dayName = "d02";
        break;
      case "d03Value":
        dayName = "d03";
        break;
      case "d04Value":
        dayName = "d04";
        break;
      case "d05Value":
        dayName = "d05";
        break;
      case "d06Value":
        dayName = "d06";
        break;
      case "d07Value":
        dayName = "d07";
        break;
    }

    return style;
  }



  return (
    <>
      <InfiniteScroll
        dataLength={rows.length}
        next={update}
        hasMore={rows.length !== (total_records || 0)}
        loader={<strong>...</strong>}
      // style={{ overflowX: "hidden" }}
      >
        <BTable bordered hover size="sm" {...getTableProps()} style={{ width: '99.9%' }}>
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map(column => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    style={formatCellStyleHeader(column)}
                  >
                    <div style={{ display: "inline-flex", alignItems: "center" }}>
                      <div style={{ display: "table-caption"}}>
                        {column.render('Header')}
                      </div>
                      {column.canSort
                        ? column.isSorted
                          ? <FontAwesomeIcon icon={column.isSortedDesc ? faSortAlphaDown : faSortAlphaUp} />
                          : <FontAwesomeIcon icon={faSort} />
                        : null
                      }
                    </div>
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {rows.map(row => {
              prepareRow(row)
              const isUpdated = row.original.isUpdated;
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => {

                    if (cell.column.id.indexOf("d01") !== -1 && !isUpdated) {
                      return <td
                        colSpan={7}
                        {...cell.getCellProps()}
                        style={{
                          background: "#fff",
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          color: '#555',
                          padding: 0,
                          opacity: isUpdated ? 1 : 0.65
                        }}
                      >
                        <div style={formatCellStyle(cell)}>
                          {msgEmpty}
                        </div>
                      </td>
                    }

                    if (!isUpdated && cell.column.id.indexOf("d0") !== -1) {
                      return <></>;
                    }
                    return (
                      <td
                        {...cell.getCellProps()}
                        style={{
                          background: "#fff",
                          textAlign: 'center',
                          verticalAlign: 'middle',
                          color: '#555',
                          padding: 0,
                          opacity: isUpdated ? 1 : 0.65
                        }}
                      >
                        <div style={formatCellStyle(cell)}>
                          {cell.render('Cell')}
                        </div>
                      </td>
                    )
                  }
                  )}
                </tr>
              )
            })}
          </tbody>
        </BTable>
      </InfiniteScroll>
    </>
  );
}


const CollectList = () => {
  const user = storageService.getUser();
  const { pathname } = useLocation();
  const [isLoading, setLoading] = useState(false);
  const { t } = useTranslation();
  const [headDate, setHeadDate] = useState<HeadDateModel>();
  const [dataset, setDataset] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)), 
    dataset: 'deposit', 
    filters: {
      transporter_id: [],
      branch_id: [],
      predictionModel_id: [],
      locale_id: [],
      equipment_id: []
    },
    sort: {
      field: 'codeEquipment',
      orientation: 'asc'
    }
  });

  const [locales, setLocales] = useState<LocaleModel[]>();
  const [transporters, setTransporters] = useState<TransporterModel[]>();
  const [branches, setBranches] = useState<BranchModel[]>();
  const [predictionModels, setPredictionModels] = useState<PredictionModelModel[]>();
  const [equipments, setEquipments] = useState<EquipmentModel[]>();

  const [showEquipmentsPickupInPeriod, setShowEquipmentsPickupInPeriod] = useState<boolean>(false);
  const [showEquipmentsEventsInPeriod, setShowEquipmentsEventsInPeriod] = useState<boolean>(false);
  const [addressClassifiedAsRisk, setAddressClassifiedAsRisk] = useState<boolean>(false);


  const [datasetDashboardAnalytical, setDatasetDashboardAnalytical] = useState<DatasetModel>({
    ...JSON.parse(JSON.stringify(DatasetDefault)),
    dataset: 'dashboard_analytical',
    filters: {
      locale_id: [],
      transporter_id: [],
      branch_id: [],
      is_pickup: null,
      is_event: null,
      is_danger: null
    },
    pagination: {
      page_number: 1,
      total_pages: 1,
      records_pages: 100,
      total_records: 0
    },
  });

  const initialize = async () => { 

    await getList(null);

    LocaleService.getAll().then((response: any) => {
      setLocales(response.result);
    });

    TransporterService.getAll().then((response: any) => {
      if (response.success === true && response.result) {
        let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'transporter' }));
        setTransporters(d.data);
      } 
      else{
        setTransporters([]);
      }
    });

    BranchService.getAll().then((response: any) => {
      if(response.success){
        let branchList = response.result.datasets.filter((dataset)=>{return dataset.dataset === 'branch'});
        setBranches(branchList[0].data);
      }else{
        setBranches([]);
      }
    });
    
    PredictionModelService.getAll().then((response: any) => {
      setPredictionModels(response.result);
    })

    EquipmentService.getAll().then((response: any) => {
      setEquipments(response.result);
    });
  };

  const handleSearch = async (event) => {
    event.preventDefault();
    await getList(null);
  };

  useEffect(() => {
    initialize();
  }, []);

  const getList = async (dataTable) => {
    setLoading(true);

    let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [datasetDashboardAnalytical] };

    if (dataTable !== null && requestParams?.datasets) {
      let dataSet = requestParams.datasets[0];
      let pagination = dataSet.pagination;

      pagination.page_number = dataTable.page_number;
      pagination.records_pages = dataTable.page_size;
      dataSet.sort.field = dataTable.sort_order.column;
      dataSet.sort.orientation = dataTable.sort_order.order;
    } else {
      let pagination = requestParams.datasets[0].pagination;
      pagination.page_number = DatasetDefault.pagination.page_number;
      pagination.records_pages = DatasetDefault.pagination.records_pages;
    }

    const response: any = await ForeCastService.getList(requestParams);

    if (response.success === true && response.result) {
      let d: DatasetModel = _.last(_.filter(response.result.datasets, { dataset: 'dashboard_analytical' }));
      setDatasetDashboardAnalytical(d);
    }
    else{
      requestParams.datasets[0].data = null;
      setDatasetDashboardAnalytical(requestParams.datasets[0]);
    }

    setLoading(false);
  };

  const handleClean = () => {
    // setDataset({
    //   ...dataset, filters: {
    //     transporter_id: [],
    //     branch_id: [],
    //     locale_id: [],
    //     code_equipment: []
    //   }
    // });
  };

  const exportFile = async (event) => {
    event.preventDefault();
    await getListExport(null);
  };

  const formatDateTime = (value) => {
    return UtilService.formatDateTime(value, user.locale.formatDate);
  };

  const formatToCurrency = (value) => {
    let decimalSeparator = user.locale?.decimalSeparator;
    let thousandSeparator = user.locale?.thousandSeparator;
    let moneyPrefix = user.locale?.moneyPrefix;
    return HelperService.number_format(value, 2, decimalSeparator, thousandSeparator);
  };

  const mock = (value) => {
   return 1;
  };
  const mockModelo = (value) => {
    return "CONFIG_PADRAO_01";
   };
   const mockPorcentagem = (value) => {
    return "0,01%";
   };

   const mockValue = (value) => {
    return "100.000,00";
   };

  const getListExport = async (dataTable) => {
  
    // let requestParams: RequestInputOutputParamsModel = { ...RequestInputOutputParamsModelDefault, datasets: [dataset] };

    
    // if (dataTable !== null && requestParams?.datasets) {
    //   let dataSet = requestParams.datasets[0];
    //   let pagination = dataSet.pagination;

    //   pagination.page_number = dataTable.page_number;
    //   pagination.records_pages = dataTable.page_size;
    //   dataSet.sort.field = dataTable.sort_order.column;
    //   dataSet.sort.orientation = dataTable.sort_order.order;
    // } else {
    //   let pagination = requestParams.datasets[0].pagination;
    //   pagination.page_number = DatasetDefault.pagination.page_number;
    //   pagination.records_pages = DatasetDefault.pagination.records_pages;
    // }

    // await EventExportService.Export(requestParams);
  };

  const [selectedDataDashboard, setSelectedDataDashboard] = useState(null);

  const data = React.useMemo(() => datasetDashboardAnalytical?.data || [], [headDate, datasetDashboardAnalytical?.data, selectedDataDashboard]);

  const columns = React.useMemo(
    () => [
      {
        Header: "Coleta Dinâmica",
        background: '#4b4b50',
        columns: [
          {
            Header: props => (<span>{"Data Planejada da Coleta"}</span>),
            accessor: "read_date",
            background: '#999999',
            disableSortBy: true,
            Cell: props => (formatDateTime(props.value))
          },
          {
            Header: props => (<span>{"Coleta Prevista"}</span>),
            accessor: "12",
            background: '#999999',
            disableSortBy: true,
            Cell: props => (mockValue(props.value))
          }
        ]
      },
      {
         Header: "Equipamento",
         background: '#0000FF',
         columns: [
           {
            Header: props => (<span>{"Coleta Realizada"}</span>),
            accessor: "1",
            background: '#6495ED',
            disableSortBy: true,
            Cell: props => (formatToCurrency(props.value))
           },
          {
            Header: props => (<span>{"Resultado Conferência"}</span>),
            accessor: "2",
            background: '#6495ED',
            disableSortBy: true,
            Cell: props => (formatToCurrency(props.value))
          }
         ]
      },
      {
        Header: "Análise",
        background: '#008000',
        columns: [
          {
            Header: props => (<span>{"Antes da Data Prevista"}</span>),
            accessor: "5",
            background: '#2E8B57',
            disableSortBy: true,
            Cell: props => (mock(props.value))
          },{
            Header: props => (<span>{"Na Data Prevista"}</span>),
            accessor: "6",
            background: '#2E8B57',
            disableSortBy: true,
            Cell: props => (mock(props.value))
          },{
            Header: props => (<span>{"Depois da Data Prevista"}</span>),
            accessor: "7",
            background: '#2E8B57',
            disableSortBy: true,
            Cell: props => (mock(props.value))
          },{
            Header: props => (<span>{"Coleta Imposta"}</span>),
            accessor: "8",
            background: '#2E8B57',
            disableSortBy: true,
            Cell: props => (mock(props.value))
          },{
            Header: props => (<span>{"Grupo de Desvio"}</span>),
            accessor: "9",
            background: '#2E8B57',
            disableSortBy: true,
            Cell: props => (mock(props.value))
          },{
            Header: props => (<span>{"Modelo de Cálculo"}</span>),
            accessor: "10",
            background: '#2E8B57',
            disableSortBy: true,
            Cell: props => (mockModelo(props.value))
          },{
            Header: props => (<span>{"Evento"}</span>),
            accessor: "11",
            background: '#2E8B57',
            disableSortBy: true,
            Cell: props => (mockPorcentagem(props.value))
          }
        ]
     }
    ],
    [headDate, datasetDashboardAnalytical?.data, selectedDataDashboard]
    );

  return (
    <>
      <HeaderList path={`${pathname}/add`} title={t(`MENU_REPORT`) + " / " + t(`MENU_REPORT_COLLECT`)} />
      <Form>
      <Form.Label className="mb-0">{t("FILTERS")}</Form.Label>

      <Row className="align-items-center">
        <Col sm={12} md={4} lg={2}>
          <Form.Group>
            <Form.Floating>
              <Form.Control
                  as='select'
                  className='form-control'
                  value={dataset?.filters?.locale_id.length > 0 ? dataset.filters.locale_id[0] : ''}
                  onChange={(e) => {
                    if (e.target.value === '') {
                      setDataset({ ...dataset, filters: { ...dataset.filters, locale_id: [] } })
                      setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, locale_id: [] } })
                      
                    } else {
                      setDataset({ ...dataset, filters: { ...dataset.filters, locale_id: [Number(e.target.value)] } })
                      setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, locale_id: [Number(e.target.value)] } })
                    }
                  }}
                >
                  <option value=''>{t("EQUIPMENT.LOCALE")}</option>
                  {_.map(locales, (l: LocaleModel) => {
                    return <option key={l.id} value={l.id}>{l.name}</option>
                  })}
                </Form.Control>
              <label>{t("FILTER.COUNTRY")}</label>
              </Form.Floating>
            </Form.Group>
          </Col>

        <Col sm={12} md={4} lg={2}>
          <Form.Group>
            <Form.Floating>
              <Form.Control
                as='select'
                className='form-control'
                value={dataset?.filters?.transporter_id.length > 0 ? dataset.filters.transporter_id[0] : ''}
                onChange={(e) => {
                  setDataset({ ...dataset, filters: { ...dataset.filters, transporter_id: [Number(e.target.value)] } })
                  setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, transporter_id: [Number(e.target.value)] } })
                }}
              >
                <option value=''>{t("EQUIPMENT.TRANSPORTERNAME")}</option>
                {_.map(transporters, (l: TransporterModel) => {
                  return <option key={l.id} value={l.id}>{l.fullName}</option>
                })}
              </Form.Control>
              <label htmlFor="status">{t("EQUIPMENT.TRANSPORTERNAME")}</label>
            </Form.Floating>
          </Form.Group>
        </Col>

        <Col sm={12} md={4} lg={2}>
          <Form.Group>
            <Form.Floating>
              <Form.Control
                as='select'
                className='form-control'
                value={dataset?.filters?.branch_id.length > 0 ? dataset?.filters?.branch_id[0] : ''}
                onChange={(e) => {
                  setDataset({ ...dataset, filters: { ...dataset.filters, branch_id: [Number(e.target.value)] } })
                  setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, branch_id: [Number(e.target.value)] } })
                }}
              >
                <option value=''>{t("FILTER.SELECT")}</option>
                {_.map(branches, (item: BranchModel) => {
                  return <option key={item.id} value={item.id}>{item.fullName}</option>
                })}
              </Form.Control>
              <label>{t("FILTER.BRANCH")}</label>
            </Form.Floating>
          </Form.Group>
        </Col>

        <Col sm={12} md={4} lg={2}>
          <Form.Group>
          <Form.Floating>
            <Form.Control
              as='select'
                className='form-control'
                value={dataset?.filters?.predictionModel_id.length > 0 ? dataset?.filters?.predictionModel_id[0] : ''}
                onChange={(e) => {
                  if (e.target.value === '') {
                    setDataset({ ...dataset, filters: { ...dataset.filters, predictionModel_id: [] } })
                    setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, predictionModel_id: [] } })
                  } else {
                    setDataset({ ...dataset, filters: { ...dataset.filters, predictionModel_id: [Number(e.target.value)] } })
                    setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, predictionModel_id: [Number(e.target.value)] } })
                  }
                }}
                >
                <option value=''>{t("EQUIPMENT.MODEL")}</option>
                {_.map(predictionModels, (l: PredictionModelModel) => {
                  return <option key={l.id} value={l.id}>{l.localeId == 0 ? t("PREDICTIONMODEL." + l.fullName.toUpperCase()) : l.fullName}</option>
                })}
            </Form.Control>
            <label>{t("FILTER.BRANCH")}</label>
            </Form.Floating>
          </Form.Group>
        </Col>

        <Col sm={12} md={4} lg={2}>
          <Form.Group>
          <Form.Floating>
            <Form.Control
              as='select'
                className='form-control'
                value={dataset?.filters?.equipment_id.length > 0 ? dataset?.filters?.equipment_id[0] : ''}
                onChange={(e) => {
                  if (e.target.value === '') {
                    setDataset({ ...dataset, filters: { ...dataset.filters, equipment_id: [] } })
                    setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, predictiequipment_idonModel_id: [] } })
                  } else {
                    setDataset({ ...dataset, filters: { ...dataset.filters, equipment_id: [Number(e.target.value)] } })
                    setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, equipment_id: [Number(e.target.value)] } })
                  }
                }}
                >
                <option value='0'>{t("FILTER.SELECT")}</option>
                {_.map(equipments, (item: EquipmentModel) => {
                  return <option key={item.id} value={item.id}>{item.codeEquipment}</option>
                })}
            </Form.Control>
            <label>{t("FILTER.EQUIPMENT")}</label>
            </Form.Floating>
          </Form.Group>
        </Col>

        <Col sm={12} md={4} lg={2}>
          <Stack gap={0}>
            <div>
              <Form.Group>
                <Form.Switch
                  id="showEquipmentsPickupInPeriod"
                  name="showEquipmentsPickupInPeriod"
                  label={t("FILTER.PICKUP")}
                  title={t("FILTER.SHOW_EQUIPMENT_WITH_PICKUP_IN_THE_PERIOD")}
                  onChange={(e) => {
                    setDataset({ ...dataset, filters: { ...dataset.filters, is_pickup: !showEquipmentsPickupInPeriod } })
                    setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, is_pickup: !showEquipmentsPickupInPeriod } })

                    setShowEquipmentsPickupInPeriod(!showEquipmentsPickupInPeriod);
                    
                  }}
                  checked={showEquipmentsPickupInPeriod}
                />
              </Form.Group>
            </div>
            <div>
              <Form.Group>
                <Form.Switch
                  id="showEquipmentsEventsInPeriod"
                  name="showEquipmentsEventsInPeriod"
                  label={t("FILTER.EVENTS")}
                  title={t("FILTER.SHOW_EQUIPMENT_WITH_EVENTS_IN_THE_PERIOD")}
                  onChange={(e) => {
                    setDataset({ ...dataset, filters: { ...dataset.filters, is_event: !showEquipmentsEventsInPeriod } })
                    setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, is_event: !showEquipmentsEventsInPeriod } })


                    setShowEquipmentsEventsInPeriod(!showEquipmentsEventsInPeriod);
                  }}
                  checked={showEquipmentsEventsInPeriod}
                />
              </Form.Group>
            </div>
            <div>
              <Form.Group>
                <Form.Switch
                  id="addressClassifiedAsRisk"
                  name="addressClassifiedAsRisk"
                  label={t("FILTER.RISK")}
                  title={t("FILTER.ADDRESS_CLASSIFIED_AS_RISK")}
                  onChange={(e) => {
                    setDataset({ ...dataset, filters: { ...dataset.filters, is_danger: !addressClassifiedAsRisk } })
                    setDatasetDashboardAnalytical({ ...datasetDashboardAnalytical, filters: { ...datasetDashboardAnalytical.filters, is_danger: !addressClassifiedAsRisk } })

                    setAddressClassifiedAsRisk(!addressClassifiedAsRisk);
                  }}
                  checked={addressClassifiedAsRisk}
                />
              </Form.Group>
            </div>
          </Stack>
        </Col>
      
        <Col xs={12} sm={12} md={12} lg={12}>

          <ButtonGroup>
            <Button onClick={handleSearch} type="submit" style={{minWidth: 100 }}>
              <span>{t("SEARCH")}</span>
            </Button>
          </ButtonGroup>
        
          <ButtonGroup>
            <Button onClick={handleClean} variant='outline-primary' style={{minWidth: 100, marginLeft: 5 }}>
              <span>{t("CLEAN")}</span>
            </Button>
          </ButtonGroup>


          <ButtonGroup>
            <Button onClick={exportFile} variant='outline-primary' style={{minWidth: 100, marginLeft: 5 }}>
              <span>{t("EXPORT")}</span>
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
      </Form>

      <Row className="align-items-center">
        <Col sm={12}>
          <Table 
          data={data} 
          columns={columns} 
          update={null} 
          total_records={datasetDashboardAnalytical?.pagination?.total_records}
          msgEmpty={t('DASHBOARD.IS_NOT_UPDATED')} />
        </Col>
      </Row>
    </>
  );
};
export default CollectList;